// extracted by mini-css-extract-plugin
export default {"mainContainer":"ServicesPage_mainContainer__5LBSG","subContainer":"ServicesPage_subContainer__H+aiO"};